import { G_EasingFunctionDefaults } from "../../../utils/globals/option-function-defaults";

/**
 * Default options
 * @returns {Map<OptionNamesProps, any>}
 */
const getDefaultOptions = () => {
  /** @type {DefaultOptionsProps} */
  return new Map([
    [
      "duration",
      new Map(
        /** @type {Array<[keyof DefaultOptionObjectProps, any]>} */
        ([
          ["is-default", true],
          ["name", "duration"],
          ["duration-divide", null],
          [
            "resolutions",
            new Map([
              [
                "current",
                new Map(
                  /** @type {Array<[string, any]>} */ ([
                    ["is-number", true],
                    ["value", 400],
                    ["unit", "ms"],
                  ])
                ),
              ],
            ]),
          ],
        ])
      ),
    ],
    [
      "pause",
      new Map(
        /** @type {Array<[keyof DefaultOptionObjectProps, any]>} */
        ([
          ["is-default", true],
          ["name", "pause"],
          ["duration-divide", null],
          [
            "resolutions",
            new Map([
              [
                "current",
                new Map(
                  /** @type {Array<[string, any]>} */ ([
                    ["is-number", true],
                    ["value", 0],
                    ["unit", "ms"],
                  ])
                ),
              ],
            ]),
          ],
        ])
      ),
    ],
    [
      "delay",
      new Map(
        /** @type {Array<[keyof DefaultOptionObjectProps, any]>} */
        ([
          ["is-default", true],
          ["name", "delay"],
          ["duration-divide", null],
          [
            "resolutions",
            new Map([
              [
                "current",
                new Map(
                  /** @type {Array<[string, any]>} */ ([
                    ["is-number", true],
                    ["value", 0],
                    ["unit", "ms"],
                  ])
                ),
              ],
            ]),
          ],
        ])
      ),
    ],
    [
      "iterations",
      new Map(
        /** @type {Array<[keyof DefaultOptionObjectProps, any]>} */
        ([
          ["is-default", true],
          ["name", "iterations"],
          ["duration-divide", null],
          [
            "resolutions",
            new Map([
              [
                "current",
                new Map(
                  /** @type {Array<[string, any]>} */ ([
                    ["is-number", true],
                    ["value", 0],
                    ["unit", null],
                  ])
                ),
              ],
            ]),
          ],
        ])
      ),
    ],
    [
      "direction",
      new Map(
        /** @type {Array<[keyof DefaultOptionObjectProps, any]>} */
        ([
          ["is-default", true],
          ["name", "direction"],
          ["duration-divide", null],
          [
            "resolutions",
            new Map([
              [
                "current",
                new Map(
                  /** @type {Array<[string, any]>} */ ([
                    ["is-string", true],
                    ["value", "normal"],
                    ["unit", null],
                  ])
                ),
              ],
            ]),
          ],
        ])
      ),
    ],
    [
      "easing",
      new Map(
        /** @type {Array<[keyof DefaultOptionObjectProps, any]>} */
        ([
          ["is-default", true],
          ["name", "easing"],
          ["duration-divide", null],
          [
            "resolutions",
            new Map([
              [
                "current",
                new Map(
                  /** @type {Array<[string, any]>} */ ([
                    ["is-string", true],
                    ["value", G_EasingFunctionDefaults.get("ease-in-out")],
                    ["unit", null],
                  ])
                ),
              ],
            ]),
          ],
        ])
      ),
    ],
    [
      "order",
      new Map(
        /** @type {Array<[keyof DefaultOptionObjectProps, any]>} */
        ([
          ["is-default", true],
          ["name", "order"],
          ["duration-divide", null],
          [
            "resolutions",
            new Map([
              [
                "current",
                new Map(
                  /** @type {Array<[string, any]>} */ ([
                    ["is-number", true],
                    ["value", 0],
                    ["unit", null],
                  ])
                ),
              ],
            ]),
          ],
        ])
      ),
    ],
  ]);
};

export default getDefaultOptions;